import React from "react";

const CompanyFooter: React.FC = () => {
  return (
    <div className="company-footer">
      <div className="footer-attribution">
        Built with{" "}
        <a href="https://vcdb.app" target="_blank" rel="noopener noreferrer">
          VCDB.app
        </a>
      </div>
    </div>
  );
};

export default CompanyFooter;
